var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-3 centeralign"},[_c('b-alert',{attrs:{"show":""}},[_vm._v(" "+_vm._s(_vm.selectedCustomer)+" Selected")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }